import { atomWithStorage } from 'jotai/utils';
import type { WorkspaceType } from '@/features/workspaces/constants';
import type { ProjectType } from '@/features/projects/constants';

export type FavoriteSubject = 'project' | 'evaluation' | 'bid' | 'procurement' | 'artifact';

export type Favorite =
  | { subject: 'evaluation'; id: string; name: string; type: WorkspaceType; projectId?: string }
  | { subject: 'project'; id: string; name: string; type?: ProjectType }
  | { subject: 'bid'; id: string; name: string; projectId?: string; evaluationId?: string }
  | { subject: 'procurement'; id: string; name: string; projectId?: string; evaluationId?: string }
  | { subject: 'artifact'; id: string; name: string; projectId?: string; evaluationId?: string };

export type StoredFavorite = {
  id: string;
  name: string;
  subject: FavoriteSubject;
  type?: string;
  projectId?: string;
  evaluationId?: string;
};

export const favoritesAtom = atomWithStorage<Record<string, StoredFavorite[]>>('favorites', {});
